<template>
    <div class="navbar navbar-expand-md navbar-dark bg-indigo">
		<div class="navbar-brand wmin-0 mr-5">
			<a :href="generateUrl('app/home')" class="d-inline-block">
				<img src="/img/logo/logotypeLightLeft.svg" alt="">
			</a>
		</div>

		<div class="d-md-none" id="mobile-navbar">
			<button class="navbar-toggler" type="button" @click="isMobileNavOpen = !isMobileNavOpen">
				<i class="icon-tree5"></i>
			</button>
		</div>

		<div class="navbar-collapse collapse justify-content-end" :class="{ show: isMobileNavOpen }" id="navbar-mobile">
			<ul class="navbar-nav">
                <TrialTariffTab/>
                <NotificationComponent v-if="!$route.meta.hideNotifications"/>
				<ContactInformationTab/>
                <LanguageTab/>
                <ProjectsTab v-if="!$route.meta.hideProjects"/>
                <ProfileTab/>
			</ul>
		</div>
	</div>
</template>
<script>
import ProfileTab from "./tabs/ProfileTab.vue";
import LanguageTab from "./tabs/LanguageTab.vue";
import ContactInformationTab from "./tabs/ContactInformationTab.vue";
import ProjectsTab from "./tabs/ProjectsTab.vue";
import TrialTariffTab from "./tabs/TrialTariffTab.vue";
import NotificationComponent from "../../../../components/NotificationComponent.vue";
import {generateUrl} from "../../../../utils";

export default {
    name: 'FirstNavbarComponent',
    components: {
    	ProfileTab, LanguageTab, ContactInformationTab, ProjectsTab, TrialTariffTab, NotificationComponent
    },
    data() {
        return {
            isMobileNavOpen: false
        }
    },
    methods: {
        generateUrl
    }
};
</script>
